import React from 'react';
import Corretores from '~/Components/Ranking/Corretores';

export default function Pages() {
  return <Corretores />;
}
